<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">平台设置</div>
      <el-form-item label="平台名称" :rules="[{ required: true, message: ' ' }]" prop="name">
        <el-input v-model="form.name" placeholder="平台名称" class="max-w460"></el-input>
        <div style="color:orange">注意：此处的名称作为平台名称和浏览器标题名称</div>
      </el-form-item>
      <el-form-item label="平台Logo：" :rules="[{ required: true, message: '请上传平台logo' }]" prop="shopImage">
        <div class="draggable-list">
          <div class="item img-select" @click="openProductUpload('image', 'shopImage')" v-if="form.shopImage == ''">
            <i class="el-icon-plus"></i>
          </div>
          <div v-if="form.shopImage != ''" class="item" @click="openProductUpload('image', 'shopImage')">
            <img :src="form.shopImage" width="100" height="100" />
          </div>
        </div>
        <div style="color:orange">注意：此图片为后台导航栏处的logo，图片比例最好为1:1</div>
      </el-form-item>

      <div class="common-form">商户后台设置</div>
      <el-form-item label="商户后台名称" :rules="[{ required: true, message: ' ' }]" prop="supplierName">
        <el-input v-model="form.supplierName" placeholder="商户后台名称" class="max-w460"></el-input>
        <div style="color:orange">注意：此处的名称作为商户后台名称和浏览器标题名称</div>
      </el-form-item>
      <el-form-item label="商户后台Logo：" :rules="[{ required: true, message: '请上传商户后台logo' }]" prop="supplierImage">
        <div class="draggable-list">
          <div class="item img-select" @click="openProductUpload('image', 'supplierImage')"
            v-if="form.supplierImage == ''">
            <i class="el-icon-plus"></i>
          </div>
          <div v-if="form.supplierImage != ''" class="item" @click="openProductUpload('image', 'supplierImage')">
            <img :src="form.supplierImage" width="100" height="100" />
          </div>
        </div>
        <div style="color:orange">注意：此图片为后台导航栏处的logo，图片比例最好为1:1</div>
      </el-form-item>

      <div class="common-form">默认头像设置</div>
      <el-form-item label="商家默认头像：" :rules="[{ required: true, message: '请上传默认的商家头像' }]" prop="waiterImage">
        <div class="draggable-list">
          <div class="item img-select" @click="openProductUpload('image', 'waiterImage')" v-if="form.waiterImage == ''">
            <i class="el-icon-plus"></i>
          </div>
          <div v-if="form.waiterImage != ''" class="item" @click="openProductUpload('image', 'waiterImage')">
            <img :src="form.waiterImage" width="100" height="100" />
          </div>
        </div>
        <div style="color:orange">注意：当商家头像的信息缺失时，我们会选择后台设置的头像进行展示，以保证系统的美观和易用性。</div>
      </el-form-item>
      <el-form-item label="用户默认头像：" :rules="[{ required: true, message: '请上传默认的用户头像' }]" prop="userImage">
        <div class="draggable-list">
          <div class="item img-select" @click="openProductUpload('image', 'userImage')" v-if="form.userImage == ''">
            <i class="el-icon-plus"></i>
          </div>
          <div v-if="form.userImage != ''" class="item" @click="openProductUpload('image', 'userImage')">
            <img :src="form.userImage" width="100" height="100" />
          </div>
        </div>
        <div style="color:orange">注意：当用户头像的信息缺失时，我们会选择后台设置的头像进行展示，以保证系统的美观和易用性</div>
      </el-form-item>
     
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <!-- <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload> -->
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import Upload from "@/components/file/Upload";
import { formatModel } from "@/utils/base.js";
export default {
  components: {
    Upload
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        name: "",
        customer: "",
        key: "",
        supplierCash: "",
        operateType: "",
        commissionRate: "",
        supplierImage: "",
        sms_open: "",
        supplier_logo: "",
        checkedCities: [],
        service: "",
        privacy: "",
        waiterImage: "",
        userImage: "",
        cityImage: "",
        channelImage: "",
        shopImage: "",
        systemVersion: 2,
        supplierName: ""

      },
      allType: [],
      type: [],
      /*是否打开图片选择*/
      isupload: false,
      isProductUpload: false,
      config: {},
      file_name: "image",
      isNotAudit: 0,//是否城市代理审核
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    /*是否开启城市代理审核*/
    CityAgent() {
      let self = this;

      SettingApi.CityAgent({ isNotAudit: self.isNotAudit }, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });

        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开上传图片*/
    openProductUpload: function (fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 9,
          fileType: "image"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "cityImage") {
          this.form.cityImage = e[0].filePath;
        } else if (this.file_name == "waiterImage") {
          this.form.waiterImage = e[0].filePath;
        } else if (this.file_name == "userImage") {
          this.form.userImage = e[0].filePath;
        } else if (this.file_name == "channelImage") {
          this.form.channelImage = e[0].filePath;
        } else if (this.file_name == "shopImage") {
          this.form.shopImage = e[0].filePath;
        } else if (this.file_name == "supplierImage") {
          this.form.supplierImage = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    },
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.storeDetail({}, true)
        .then(res => {
          let vars = res.data;
          self.form = formatModel(self.form, vars);

          // self.form.checkedCities = res.data.vars.values.delivery_type;
          // // 转成整数，兼容组件
          // for (let i = 0; i < self.form.checkedCities.length; i++) {
          //   self.$set(
          //     self.form.checkedCities,
          //     i,
          //     parseInt(self.form.checkedCities[i])
          //   );
          // }
          // self.type = vars.delivery_type;
          // self.form.customer = vars.kuaidi100.customer;
          // self.form.key = vars.kuaidi100.key;
          // self.form.service = vars.policy.service;
          // self.form.privacy = vars.policy.privacy;
          // self.allType = res.data.allType;
          self.loading = false;
        })
        .catch(error => { });
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
     
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，设置成功",
                type: "success"
              });
              self.$router.push("/setting/store/index");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    renumber(e) {
      var keynum = window.event ? e.keyCode : e.which;
      var keycar = String.fromCharCode(keynum);
      if (keynum == 189 || keynum == 190 || keynum == 110 || keynum == 109) {
        this.$message.warning("禁止输入小数和负数");
        e.target.value = "";
      }
    },
    /*选择图片*/
    chooseImg(e) {
      this.type = e;
      this.isupload = true;
    }
  }
};
</script>
<style>
.tips {
  color: #ccc;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper>span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue